module.exports = __webpack_public_path__ + "media/images/icon-gifts-e966bf8588115a82e7b1bd32dab53481.svg";